// Pagos y devoluciones — copiar datos bancarios al portapapeles
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.pyd-copy-btn');
  if (!btn) return;

  var text = btn.getAttribute('data-copy') || '';

  function fallbackCopy() {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (err) {}
    document.body.removeChild(ta);
  }

  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(text).catch(fallbackCopy);
  } else {
    fallbackCopy();
  }

  var toast = document.getElementById('pyd-toast');
  if (toast) {
    toast.classList.add('show');
    clearTimeout(window.__pydToastTimer);
    window.__pydToastTimer = setTimeout(function () {
      toast.classList.remove('show');
    }, 1400);
  }
});
